import React, { useState } from "react"
import {
  Box,
  Text,
  Heading,
  Input,
  Button,
  Flex,
  Label,
} from "@theme-ui/components"

import { BsChevronRight } from "react-icons/bs"
import { Textarea, Checkbox } from "theme-ui"
import axios from "axios"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"
import { i18nContext } from "../../context/i18nContext"

const BareContactForm = ({ contactPage = true, alternateLayout = false }) => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  const isBrowser = typeof window !== "undefined"

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    messaggio: "",
    accordoPrivacyCookies: false,
    accordoNewsLetter: false,
    urlPagina: isBrowser && window.location.href,
  })

  const [loading, setLoading] = useState(null)
  const [success, setSuccess] = useState(null)

  const sendMail = async event => {
    event.preventDefault()
    if (isBrowser) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "form_submit_contact",
        formType: "Contact",
        pageURL: window.location.href,
      })
    }
    const result = await executeRecaptcha("dynamicAction")
    setLoading(true)
    const data = formData

    if (result)
      axios
        .post("/.netlify/functions/sendMail", data)
        .then(function (response) {
          setSuccess(true)
          setLoading(false)
        })
        .catch(function (error) {
          setLoading(false)
          setSuccess(false)
        })
    else {
      setLoading(false)
      setSuccess(false)
    }
  }

  return (
    <i18nContext.Consumer>
      {t => (
        <Box as="form" onSubmit={sendMail} sx={{ my: [4] }}>
          <Box>
            <Flex sx={{ flexWrap: "wrap" }}>
              <Box
                sx={{
                  pr: [0, 1, 1, 1],
                  pb: [3, 3, 3, 3],
                  width: ["100%", "50%"],
                }}
              >
                <Input
                  onChange={e =>
                    setFormData(prevState => ({
                      ...prevState,
                      firstName: e.target.value,
                    }))
                  }
                  name={t.formInputTexts.firstName}
                  placeholder={t.formInputTexts.firstName + "*"}
                  variant={"inputs.primary"}
                  required
                />
              </Box>
              <Box
                sx={{
                  pl: [0, 1, 1, 1],
                  pb: [3, 3, 3, 3],
                  width: ["100%", "50%"],
                }}
              >
                <Input
                  onChange={e =>
                    setFormData(prevState => ({
                      ...prevState,
                      lastName: e.target.value,
                    }))
                  }
                  name={t.formInputTexts.lastName}
                  placeholder={t.formInputTexts.lastName + "*"}
                  variant={"inputs.primary"}
                  required
                />
              </Box>
            </Flex>
            <Flex sx={{ flexWrap: "wrap" }}>
              <Box
                sx={{
                  pr: [0, 1, 1, 1],
                  pb: [3, 3, 3, 3],
                  width: ["100%", "50%"],
                }}
              >
                <Input
                  onChange={e =>
                    setFormData(prevState => ({
                      ...prevState,
                      email: e.target.value,
                    }))
                  }
                  name={t.formInputTexts.email}
                  placeholder={t.formInputTexts.email + "*"}
                  type="email"
                  variant={"inputs.primary"}
                  required
                />
              </Box>
              <Box
                sx={{
                  pl: [0, 1, 1, 1],
                  pb: [3, 3, 3, 3],
                  width: ["100%", "50%"],
                }}
              >
                <Input
                  onChange={e =>
                    setFormData(prevState => ({
                      ...prevState,
                      phone: e.target.value,
                    }))
                  }
                  type="text"
                  name={t.formInputTexts.phone}
                  placeholder={t.formInputTexts.phone + "*"}
                  variant={"inputs.primary"}
                  required
                />
              </Box>
            </Flex>

            {alternateLayout ? (
              <Flex sx={{ flexWrap: "wrap" }}>
                <Box
                  sx={{
                    pr: [0, 1, 1, 1],
                    pb: [3, 3, 3, 3],
                    width: ["100%", "50%"],
                  }}
                >
                  <Input
                    onChange={e =>
                      setFormData(prevState => ({
                        ...prevState,
                        company: e.target.value,
                      }))
                    }
                    name={t.formInputTexts.company}
                    placeholder={t.formInputTexts.company + "*"}
                    variant={"inputs.primary"}
                    required
                  />
                </Box>
                <Box
                  sx={{
                    pl: [0, 1, 1, 1],
                    pb: [3, 3, 3, 3],
                    width: ["100%", "50%"],
                  }}
                >
                  <Textarea
                    sx={{
                      fontFamily: "body",
                      fontSize: [2],
                    }}
                    onChange={e =>
                      setFormData(prevState => ({
                        ...prevState,
                        message: e.target.value,
                      }))
                    }
                    name={t.formInputTexts.message}
                    placeholder={t.formInputTexts.message}
                    variant={"inputs.primary"}
                    type="textarea"
                    rows={1}
                  />
                </Box>
              </Flex>
            ) : (
              <>
                <Flex sx={{ flexWrap: "wrap" }}>
                  <Box
                    sx={{
                      pr: [0, 0, 0, 0],
                      pb: [3, 3, 3, 3],
                      width: ["100%", "100%"],
                    }}
                  >
                    <Input
                      onChange={e =>
                        setFormData(prevState => ({
                          ...prevState,
                          company: e.target.value,
                        }))
                      }
                      name={t.formInputTexts.company}
                      placeholder={t.formInputTexts.company + "*"}
                      variant={"inputs.primary"}
                      required
                    />
                  </Box>
                </Flex>

                <Textarea
                  sx={{
                    fontFamily: "body",
                    fontSize: [2],
                  }}
                  onChange={e =>
                    setFormData(prevState => ({
                      ...prevState,
                      message: e.target.value,
                    }))
                  }
                  name={t.formInputTexts.message}
                  placeholder={t.formInputTexts.message}
                  variant={"inputs.primary"}
                  type="textarea"
                />
              </>
            )}

            <LabeledCheckbox
              checkedCheckbox={e => {
                setFormData(prevState => ({
                  ...prevState,
                  agreementPrivacyCookies: e,
                }))
              }}
              required={true}
              contactPage={contactPage}
            >
              <Box>
                <Text
                  variant="p"
                  sx={{
                    fontSize: [0],
                    color: contactPage ? "dark" : "light",
                  }}
                >
                  *{" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t.formInputTexts.policy,
                    }}
                  />
                </Text>
              </Box>
            </LabeledCheckbox>
            <LabeledCheckbox
              checkedCheckbox={e =>
                setFormData(prevState => ({
                  ...prevState,
                  agreementNewsLetter: e,
                }))
              }
              contactPage={contactPage}
            >
              <Box>
                <Text variant="p" sx={{ fontSize: [0] }}>
                  {t.formInputTexts.privacy}
                </Text>
              </Box>
            </LabeledCheckbox>

            <Button
              type="submit"
              title={
                !formData.accordoPrivacyCookies
                  ? "Acconsenti al trattamenti dei dati personali"
                  : ""
              }
              sx={{
                width: alternateLayout ? "auto" : "100%",
                mt: [3, 3, 3, 3],
                py: [3],
                opacity: !formData.accordoPrivacyCookies && 0.9,
                borderRadius: "20px 0 20px 0",
                "&:hover": {
                  color: "light",
                  svg: {
                    circle: {
                      stroke: "light",
                      strokeWidth: "2px",
                    },
                    use: {
                      fill: "light",
                    },
                    "g#Group": {
                      fill: "light",
                    },
                  },
                },
              }}
              disabled={loading}
            >
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {loading ? t.formInputTexts.loading : t.formInputTexts.submit}
                <Box
                  as="span"
                  className="icon"
                  sx={{
                    border: "1px solid",
                    borderColor: "light",
                    width: "25px",
                    height: "25px",
                    borderRadius: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <BsChevronRight size={16} />
                </Box>
              </Flex>
            </Button>
            {success === true ? (
              <Flex sx={{ maxWidth: "600px" }}>
                <Heading
                  sx={{
                    my: [4],
                    color: contactPage ? "dark" : "light",
                    fontSize: [3],
                  }}
                  as="p"
                >
                  Richiesta inviata! Ti ricontatteremo al più presto.
                </Heading>
              </Flex>
            ) : (
              success === false && (
                <Flex sx={{ maxWidth: "600px" }}>
                  <Heading
                    sx={{
                      my: [4],
                      color: contactPage ? "dark" : "light",
                    }}
                    as="h5"
                  >
                    Qualcosa è andato storto
                  </Heading>
                </Flex>
              )
            )}
          </Box>
        </Box>
      )}
    </i18nContext.Consumer>
  )
}

const LabeledCheckbox = ({
  children,
  defaultChecked,
  contactPage,
  checkedCheckbox,
  ...props
}) => {
  const [checked, setChecked] = useState(defaultChecked)

  return (
    <Label
      sx={{
        display: "flex",
        alignItems: "center",
        fontWeight: checked ? "bold" : "normal",
        color: contactPage ? "dark" : "light",
        a: {
          color: contactPage ? "dark" : "light",
        },
        "input:checked~.css-kydphz": {
          color: "light",
        },
        svg: {
          color: contactPage ? "lightGrey" : "light",
        },
        mt: [3, 3, 3, 3],
      }}
    >
      <Checkbox
        sx={{
          color: !contactPage && "light",
          "input:checked~&": {
            color: !contactPage && "light",
          },
        }}
        checked={checked}
        onChange={() => {
          checkedCheckbox(!checked)
          setChecked(!checked)
        }}
        {...props}
      />
      {children}
    </Label>
  )
}

export default BareContactForm
